import { UserService } from '@duck/api-definitions'

export const supportedGUILanguages = Object.values(UserService.UserSettingsGuiLanguageEnum)
